export default __webpack_public_path__ + "static/media/category_question.13155195.svg";